<template>
  <div id="app" :class="{scrolled: $store.state.isScrolled, loaded: $store.state.isPageLoaded}" :mq="$store.state.currentMq">
    <transition
      name="pairs"
      @before-enter="beforeEnter"
      @after-enter="afterEnter">
    >
      <router-view
        class="body-content"
        ref="content"
      />
    </transition>
    <!-- <Console /> -->
    <MyLoader :percentage="percentage"></MyLoader>
  </div>
</template>

<script>
import axios from 'axios'
import Console from './components/Console'
import { TweenLite, Power2 } from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { debounce } from 'lodash'
import { getBodyScrollTop } from './bin/helpers'
import MyLoader from './modules/myLoader'

export default {
  name: 'App',
  components: {
    Console,
    MyLoader
  },
  data () {
    return {
      isLoaded: false,
      posts: null,
      homeTopPosition: 0,
      detailTopPosition: 0,
      percentage: 0,
      imageTotal: 0,
      imageLoaded: 0
    }
  },
  computed: {
    rootClass () {
      return this.$route.name
    }
  },
  mounted () {
    const self = this
    this.isLoaded = true

    document.body.classList.add('transition')

    window.addEventListener('resize', debounce(function () {
      self.$store.commit('updateMediaQuery')
    }, 1000))
    self.$store.commit('updateMediaQuery')

    this.assignAgentClassToBody()
    this.disableContextMenu()

    const promiseProducts = axios.get('https://yuyamadesign.com/media/wp-json/wp/v2/work?per_page=100')
    const promiseBlogs = axios.get('https://yuyamadesign.com/media/wp-json/wp/v2/posts?per_page=100')

    Promise.all([promiseProducts, promiseBlogs]).then(function (val) {
      const images = val[0].data.map(x => x.featured_image_src)
      const localImages = self.toArray(document.getElementsByTagName('img')).map(x => x.src)
      self.$store.commit('ProductArticle/initialize', val[0].data)
      self.$store.commit('BlogArticle/initialize', val[1].data)

      // console.log(images.concat(localImages))
      self.initLoader(images.concat(localImages))
    })
  },
  methods: {
    scrollWindowTo: function (hash) {
      if (document.getElementById(hash.replace('#', '')) === null) return false
      TweenLite.to(window, 1, {scrollTo: {y: hash, autoKill: false}, ease: Power2.easeOut})
    },
    beforeEnter: function (el, done) {
      const routeName = this.$route.name
      if (routeName === 'detail' || routeName === 'media') {
        this.homeTopPosition = getBodyScrollTop.top
        // console.log('beforeEnter/home: ', this.homeTopPosition)
      }
      if (routeName === 'home') {
        this.detailTopPosition = getBodyScrollTop.top
        getBodyScrollTop.top = this.homeTopPosition
      }
    },
    afterEnter: function (el, done) {
      const routeName = this.$route.name
      if (routeName === 'detail' || routeName === 'media') {
        getBodyScrollTop.top = 0
      }
      if (routeName === 'home') {
        if (window.location.hash === '') {
          getBodyScrollTop.top = this.homeTopPosition
        }
      }
    },
    disableContextMenu: function () {
      document.addEventListener('contextmenu', function (event) {
        event.preventDefault()
      }, true)
    },
    initLoader: function (images) {
      const self = this
      let promises = []
      this.imageTotal = images.length - 1
      for (let i = 0; i <= this.imageTotal; i++) {
        const imgElm = new Image()
        const imgPromise = new Promise(function (resolve) {
          imgElm.addEventListener('load', function () {
            self.imageLoaded++
            if (self.imageLoaded > self.imageTotal) self.imageLoaded = self.imageTotal
            self.percentage = Math.floor(
              (self.imageLoaded / self.imageTotal) * 100
            )
            // console.log( self.imageLoaded, ' / ', self.imageTotal)
            resolve()
          })
          imgElm.src = images[i]
        })
        promises.push(imgPromise)
      }
      Promise.all(promises).then(function () {
        console.info('Images are loaded successfully')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style-type: none;
    display: inline-block;
  }
  a {
    display: inline-block;
    margin: 0 10px;
  }
  + div {
    padding-top: 0.5em;
    margin-top: 1em;
    font-weight: bold;
    font-size: 2em;
  }
}
.body-content {
  position: relative;
  overflow: hidden;
  &:before {
    content: " ";
    position: fixed;
    transform: rotate(45deg);
    transition: all 0.3s ease-out;
    width: 200%;
    height: 200%;
    top: 100%;
    left: 100%;
    background-color: #fff;
  }
  &.hide {
    &:before {
      top: -20%;
      left: -20%;
    }
  }
}
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.pairs-enter, .pairs-enter-to {
  position: relative;

  &.c-about {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
  }
}
.pairs-enter-active {
  &.c-home {
    will-change: transform;
    animation: slide-in-2left 1s cubic-bezier(.31,.94,.75,1);
  }
  &.c-about {
    will-change: transform;
    animation: slide-in 1s cubic-bezier(.31,.94,.75,1);
  }
}
.pairs-leave, .pairs-leave-to {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  &.c-about {
    position: fixed;
    z-index: 100;
  }
}
.pairs-leave-active {
  &.c-about {
    will-change: transform;
    animation: slide-out-2right 1s cubic-bezier(.31,.94,.75,1);
  }
  &.c-home {
    will-change: transform;
    animation: slide-out-2left 1s cubic-bezier(.31,.94,.75,1);
  }
}

@keyframes slide-in {
  0% {
    // right: -100vw;
    transform: translateX(100vw);
  }
  100% {
    // right: 0;
    transform: translateX(0);
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes slide-out-2right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100vw);
  }
}
@keyframes slide-out-2left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-100vw);
    opacity: 0;
  }
}
@keyframes slide-in-2left {
  0% {
    transform: translateX(-100vw);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue